export default "__VITE_ASSET__7EjC$wLn__"